import { FX_SOLUTION_DETAIL, SERVICES_DETAIL } from "./solutionContent";

export { FX_SOLUTION_DETAIL, SERVICES_DETAIL };

export const BRAND = {
  name: "FX Broker Xpert",
  shortName: "FXBX",
  tagline: "Broker technology, made operational",
  domain: "fxbrokerxpert.com",
  logo: "/brand-mark.svg",
  email: "support@fxbrokerxpert.com",
  email2: "sales@fxbrokerxpert.com",
  phone: "+1 (939) 221-0675",
  socials: {
    twitter: "#",
    facebook: "#",
    instagram: "#",
    linkedin: "#",
  },
};

export const HERO_IMAGES = [
  "https://static.prod-images.emergentagent.com/jobs/d607f970-7256-4c21-bc72-36de5919c454/images/9d6841cd12d516bed346a39d95f119a6b3f7d80d001c679d9fc4e70681428e8b.png",
  "https://images.pexels.com/photos/12955791/pexels-photo-12955791.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920",
  "https://images.pexels.com/photos/10628030/pexels-photo-10628030.png?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920",
];

export const CRM_IMAGE =
  "https://images.pexels.com/photos/7567443/pexels-photo-7567443.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";
export const ABOUT_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/d607f970-7256-4c21-bc72-36de5919c454/images/9d6841cd12d516bed346a39d95f119a6b3f7d80d001c679d9fc4e70681428e8b.png";
export const KYC_IMAGE =
  "https://images.pexels.com/photos/12955791/pexels-photo-12955791.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";

export const NAV_ITEMS = [
  { label: "Overview", href: "/", icon: "Home" },
  { label: "Broker Stack", href: "/#fx", icon: "Cpu", hasDropdown: true, dropdownId: "fx" },
  {
    label: "Funded Solutions",
    href: "/#funded-form",
    icon: "ClipboardList",
    hasDropdown: true,
    dropdownId: "funded",
  },
  { label: "Digital Services", href: "/#services", icon: "Wrench", hasDropdown: true, dropdownId: "services" },
  { label: "Our Story", href: "/about", icon: "Info" },
  { label: "Connect", href: "/contact", icon: "Phone" },
];

export const FX_DROPDOWN = [
  {
    group: "Core platform",
    items: [
      { title: "Forex CRM", slug: "forex-crm", desc: "Operator-focused CRM for today's broker workflows.", icon: "Sparkles" },
      { title: "Forex Web Design", slug: "forex-web-design", desc: "Broker websites engineered for conversion.", icon: "Layout" },
      { title: "Liquidity Bridge", slug: "liquidity-bridge", desc: "Connect to institutional liquidity with confidence.", icon: "Waves" },
      { title: "Prop Firm CRM", slug: "prop-firm-crm", desc: "Evaluation and payout logic for prop operators.", icon: "Lock" },
    ],
  },
  {
    group: "Infrastructure & tools",
    items: [
      { title: "Forex Copier", slug: "forex-copier", desc: "Reliable trade mirroring between master and follower accounts.", icon: "Repeat2" },
      { title: "Dedicated Server", slug: "dedicated-server", desc: "Performance-tuned MT4 / MT5 server hosting.", icon: "Database" },
      { title: "Backend Solutions", slug: "backend-solutions", desc: "Back-office consoles, gateways, and reporting layers.", icon: "Globe" },
      { title: "VPS Hosting", slug: "vps-hosting", desc: "Resilient virtual servers for automated strategies.", icon: "Server" },
      { title: "Custom Tools", slug: "custom-tools", desc: "Bespoke utilities aligned to your desk processes.", icon: "Rocket" },
      {
        title: "Engineering",
        href: "/web-tech",
        desc: "Frontend standards, API design, and release practices for trading products.",
        icon: "Code2",
      },
    ],
  },
];

/** Mega-menu columns for the Funded Form nav item (`dropdownId: "funded"`). */
export const FUNDED_FORM_DROPDOWN = [
  {
    group: "Programs & growth",
    items: [
      {
        title: "CRM Marketing Prop Firm",
        slug: "crm-marketing-prop-firm",
        desc: "Positioning, campaigns, and funnel assets tuned for prop-firm and funded-trader programs.",
        icon: "Megaphone",
      },
      {
        title: "CRM Prop Form Tool",
        slug: "crm-prop-form-tool",
        desc: "Configurable forms and workflows for evaluations, payouts, and trader lifecycle events.",
        icon: "FileSpreadsheet",
      },
    ],
  },
  {
    group: "Operations & compliance",
    items: [
      {
        title: "Regulations",
        slug: "regulations",
        desc: "Compliance-aligned setups and partner checks for funded-program operators.",
        icon: "Landmark",
      },
      {
        title: "Consulting",
        slug: "consulting",
        desc: "Launch planning, vendor choices, and operating-model advisory for funded desks.",
        icon: "UserStar",
      },
      {
        title: "Risk Management",
        slug: "risk-management",
        desc: "Exposure, concentration, and policy-backed limits across funded accounts.",
        icon: "ShieldAlert",
      },
      {
        title: "Manpower",
        slug: "manpower",
        desc: "Staffing and team augmentation so your funded desk can scale operations cleanly.",
        icon: "Users",
      },
    ],
  },
];

export const FX_SOLUTION_CROSS_LINKS = [
  { label: "Our Story", href: "/about", blurb: "Who we are and how we deliver." },
  { label: "Digital Services", href: "/#services", blurb: "Web, mobile, and CRM project lanes." },
  { label: "Engineering", href: "/web-tech", blurb: "Stack, performance, and release standards." },
  { label: "Connect", href: "/contact", blurb: "Start a conversation with our team." },
];

function pickDropdownForSlug(slug) {
  for (const col of FX_DROPDOWN) {
    const item = col.items.find((i) => i.slug === slug);
    if (item) return { col, item, parentSection: "Broker Stack", parentSectionHref: "/#fx" };
  }
  for (const col of FUNDED_FORM_DROPDOWN) {
    const item = col.items.find((i) => i.slug === slug);
    if (item) return { col, item, parentSection: "Funded Solutions", parentSectionHref: "/#funded-form" };
  }
  return null;
}

export function getFxSolutionBySlug(slug) {
  const detail = FX_SOLUTION_DETAIL[slug];
  if (!detail) return null;
  const picked = pickDropdownForSlug(slug);
  if (!picked) return null;
  const { col, item, parentSection, parentSectionHref } = picked;
  return {
    ...item,
    group: col.group,
    intro: detail.intro,
    paragraphs: detail.paragraphs,
    highlights: detail.highlights,
    parentSection,
    parentSectionHref,
  };
}

export const HERO_FEATURES = [
  { title: "Security engineered into every layer", icon: "ShieldCheck", accent: "blue" },
  { title: "Fast, dependable execution routes", icon: "Zap", accent: "orange" },
  { title: "Launch support led by specialists", icon: "Users", accent: "blue" },
  { title: "Operational help whenever markets move", icon: "Headphones", accent: "orange" },
];

export const HERO_STATS = [
  { value: "500+", label: "Projects delivered" },
  { value: "99.9%", label: "Uptime objective" },
  { value: "24/7", label: "Technical coverage" },
];

export const ABOUT_FEATURES = [
  { icon: "Zap", text: "Next-generation trader UI — sharp layout, mobile-ready, built for speed" },
  { icon: "Repeat", text: "Smooth client onboarding with live KYC verification" },
  { icon: "Users", text: "PAMM and MAM modules with native investor tooling" },
  { icon: "LayoutDashboard", text: "Single Trader's Room hub with deep performance insights" },
  { icon: "Network", text: "Flexible IB network — multi-tier and built to grow" },
  { icon: "GitFork", text: "Enterprise-grade trade copier — straightforward setup, serious throughput" },
];

/** DOM id / URL hash for each homepage service row — keep in sync with `Services.jsx`. */
export function serviceSectionHashId(title) {
  const slug = title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
  return `service-${slug}`;
}

/** URL slug for each service page under `/services/:slug`. */
export function serviceSlug(title) {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

export const SERVICES = [
  { title: "Static Website Development", desc: "Fast, search-ready brand websites that turn broker traffic into qualified enquiries.", icon: "FileText" },
  { title: "Dynamic Web Platforms", desc: "Interactive portals and web products designed around your client journey.", icon: "RefreshCw" },
  { title: "E-commerce Builds", desc: "Secure digital storefronts prepared for payments, growth, and daily operations.", icon: "ShoppingCart" },
  { title: "Android App Development", desc: "Responsive Android products with intuitive flows and production-grade stability.", icon: "Smartphone" },
  { title: "iOS App Development", desc: "Polished iPhone and iPad experiences built for speed, trust, and retention.", icon: "Apple" },
  { title: "CRM Consulting", desc: "Practical guidance for choosing a CRM that fits your sales and dealing teams.", icon: "Headphones" },
  { title: "CRM Implementation", desc: "Structured configuration, migration, testing, and rollout with minimal disruption.", icon: "Settings" },
  { title: "CRM Integration", desc: "Connected data across trading platforms, payments, KYC, support, and reporting.", icon: "Link" },
];

function serviceToMegaMenuItem(s) {
  const slug = serviceSlug(s.title);
  return {
    title: s.title,
    desc: s.desc,
    icon: s.icon,
    slug,
    kind: "service",
  };
}

/** Mega-menu columns for the Services nav item (`dropdownId: "services"`). */
export const SERVICES_DROPDOWN = [
  {
    group: "Websites & commerce",
    items: [SERVICES[0], SERVICES[1], SERVICES[2]].map(serviceToMegaMenuItem),
  },
  {
    group: "Mobile apps",
    items: [SERVICES[3], SERVICES[4]].map(serviceToMegaMenuItem),
  },
  {
    group: "CRM",
    items: [SERVICES[5], SERVICES[6], SERVICES[7]].map(serviceToMegaMenuItem),
  },
];

export function getServiceBySlug(slug) {
  const base = SERVICES.find((s) => serviceSlug(s.title) === slug);
  if (!base) return null;
  const detail = SERVICES_DETAIL[slug];
  if (!detail) return null;
  return {
    ...base,
    slug,
    intro: detail.intro,
    paragraphs: detail.paragraphs,
    highlights: detail.highlights,
  };
}

export const WHY_CHOOSE_FAQ = [
  { q: "A single partner across the broker technology stack", a: "Strategy, product design, implementation, integrations, and support stay with one accountable team from first workshop to production." },
  { q: "People who understand both trading and software", a: "Our specialists translate operational requirements into reliable systems without losing the realities of risk, compliance, and client service." },
  { q: "Solutions fitted to your operating model", a: "Every engagement reflects your workflows, permissions, jurisdictions, and growth plans instead of forcing your team into a generic template." },
  { q: "Technology selected for measurable business value", a: "We prioritize resilient architecture, practical automation, and maintainable tooling over features that look impressive but add complexity." },
  { q: "Clear milestones and visible progress", a: "Defined deliverables, regular demonstrations, and transparent commercial terms keep decisions simple and projects under control." },
];

export const COMPLIANCE_POINTS = [
  { title: "Licensed partners only", desc: "Integrations are limited to vetted, properly licensed broker partners." },
  { title: "Software vendor — not a broker", desc: "We supply technology only and do not provide investment advice or trade execution." },
  { title: "Compliance-aware delivery", desc: "Workflows are implemented to align with KYC, AML, and partner regulatory requirements." },
];

export const CTA_POINTS = [
  { icon: "Lightbulb", text: "Purpose-built solutions for your operating model" },
  { icon: "Users", text: "Experienced engineers on every go-live" },
  { icon: "Timer", text: "Efficient delivery with dependable handover" },
  { icon: "ShieldCheck", text: "Secure architecture designed to scale" },
];

export const MARQUEE_ITEMS = [
  { icon: "Users", text: "Experienced engineering squad" },
  { icon: "Award", text: "ISO-aligned project practices" },
  { icon: "Zap", text: "Ultra-low-latency routing" },
  { icon: "Phone", text: "Always-on support coverage" },
  { icon: "Globe", text: "Multi-region infrastructure" },
  { icon: "ShieldCheck", text: "Institutional-grade protection" },
];

export const PROCESS_STEPS = [
  { num: "01", title: "Understand", desc: "We map your business model, users, systems, priorities, and regulatory constraints." },
  { num: "02", title: "Design", desc: "You receive a focused blueprint covering experience, architecture, integrations, and delivery." },
  { num: "03", title: "Deliver", desc: "Working software arrives in short cycles, with frequent reviews and early validation." },
  { num: "04", title: "Optimize", desc: "We support launch, monitor performance, and improve the platform as your operation grows." },
];

export const REGULATIONS = [
  { code: "FCA", country: "United Kingdom", focus: "MiFID II / EMIR" },
  { code: "CySEC", country: "Cyprus", focus: "EU passporting" },
  { code: "ASIC", country: "Australia", focus: "Retail & wholesale" },
  { code: "FSCA", country: "South Africa", focus: "ODP licensing" },
  { code: "DFSA", country: "UAE — DIFC", focus: "Cat 3A / 4" },
  { code: "VFSC", country: "Vanuatu", focus: "Offshore retail" },
  { code: "FSA", country: "Seychelles", focus: "Securities dealer" },
  { code: "MAS", country: "Singapore", focus: "CMS license" },
];

export function navItemPath(item) {
  const map = {
    "/": "/",
    "/#home": "/",
    "/#about": "/about",
    "/#services": "/#services",
    "/#contact": "/contact",
    "/contact": "/contact",
    "/about": "/about",
    "/#fx": "/#fx",
    "/#funded-form": "/#funded-form",
  };
  return map[item.href] ?? item.href;
}

export function dropdownItemPath(item) {
  if (item.kind === "service" && item.slug) return servicePath(item.slug);
  if (item.slug) return `/solutions/${item.slug}`;
  if (item.href === "/web-tech" || item.href === "/#web-tech") return "/web-tech";
  return item.href;
}

export function servicePath(slug) {
  return `/services/${slug}`;
}

export const ALL_SOLUTION_SLUGS = [
  ...FX_DROPDOWN.flatMap((col) => col.items.filter((i) => i.slug).map((i) => i.slug)),
  ...FUNDED_FORM_DROPDOWN.flatMap((col) => col.items.filter((i) => i.slug).map((i) => i.slug)),
];

export const FX_PRODUCTS = ALL_SOLUTION_SLUGS.map((slug) => {
  const s = getFxSolutionBySlug(slug);
  if (!s) return null;
  return {
    slug,
    title: s.title,
    group: s.group,
    icon: s.icon,
    lede: s.intro,
    headline: s.intro,
    features: s.highlights,
    useCases: [],
  };
}).filter(Boolean);

const FUNDED_FORM_SLUGS = FUNDED_FORM_DROPDOWN.flatMap((col) =>
  col.items.filter((i) => i.slug).map((i) => i.slug)
);

/** Funded Form product pages — subset of `FX_PRODUCTS` for `/funded-form/:slug` routes. */
export const FUNDED_FORM_PRODUCTS = FUNDED_FORM_SLUGS.map((slug) =>
  FX_PRODUCTS.find((p) => p.slug === slug)
).filter(Boolean);

export const NAV_ROUTES = NAV_ITEMS.map((item, i) => ({
  num: String(i + 1).padStart(2, "0"),
  label: item.label,
  path: navItemPath(item),
  ...(item.hasDropdown ? { hasMega: true } : {}),
  ...(item.dropdownId ? { dropdownId: item.dropdownId } : {}),
}));
